'use client'
import { useEffect, useState } from 'react';
import Image from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils"
import { WorkflowFeatures } from "@/components/site/sections/widgets/WorkflowFeatures"
import { NoteFeatures } from "@/components/site/sections/widgets/NoteFeatures"
import { TokenIcon } from "@/components/fun-ui/icons"
import { NoteSwitchers } from "@/components/site/sections/widgets/NoteSwitchers"
import { HeroSection } from "@/components/site/sections/HeroSection"
import { buttonVariants } from "@/components/fun-ui/Button";
import { useRouter } from 'next/navigation';
import { SiteFollowUs } from '@/components/site/SiteFollowUs';

export default function IndexPage() {
  const router = useRouter();
  const [cookieHasNickname, setCookieHasNickname] = useState(true);
  useEffect(() => {
    setCookieHasNickname(document.cookie.indexOf('nickname') !== -1);
  }, []);

  return (
    <>
      <HeroSection />
      <section className="flex flex-col items-center justify-center bg-background">
        <div className={cn(
          "flex flex-col flex-1 items-center mt-[112px] mb-[116px]",
        )}>
          <h2 className={cn(
            "relative",
            "font-semibold text-[42px]"
          )}>
            信赖我们的用户来自
          </h2>
          <div className="mt-[26px] ">
            <Image
              priority
              className="h-auto"
              width={1200}
              height={253.5}
              src="https://oss.findinai.cn/images/new-section-10-our-trusted-users-come-from.png"
              alt="信赖我们的用户来自"
            />
          </div>
        </div>
      </section>
      {/* 视频轮播模块 */}
      <section
        className="relative flex justify-center overflow-hidden min-w-full bg-[#EDEFF4]"
      >
        <div className="container flex flex-col items-center z-[2] bg-transparent">
          <h2 className={cn(
            "relative",
            "font-semibold text-[42px] mt-[102px]"
          )}>
            在 Findin ，用 AI 加速学术研究工作流
          </h2>
          <WorkflowFeatures />
        </div>
        <Image
          priority
          className="absolute left-1/2 -translate-x-1/2 z-[1]"
          width={1440}
          height={1117}
          src="https://oss.findinai.cn/images/new-section-bg-01-in-findin-using-ai-to-accelerate-academic-research-workflow.png"
          alt=""
        />
      </section>
      <section
        className="relative flex justify-center overflow-hidden min-w-full bg-[#EDEFF4]"
      >
        <div className="container flex flex-col z-[2]">
          <h2 className="text-[40px] leading-[52px] font-semibold mt-28">
            每天文献<br />
            看不过来？<br />
            <span className="text-primary">先用 AI 快速筛选。</span>
          </h2>
          <p className="text-muted-foreground text-sm leading-7 mt-7">
            上传感兴趣的文献， <br />用 AI 自动总结你所关心的关键信息，一张表格快速预览掌控文献概况。
          </p>
          <div className="-mx-[42px] mt-5 mb-[56px]">
            <Image
              className=""
              width={1170}
              height={929}
              src="https://oss.findinai.cn/images/new-section-02-daily-literature-overwhelmed-try-ai-quick-screening.png"
              alt="每天文献 看不过来？ 先用 AI 快速筛选。"
            />
            <div className="sr-only">
              <h5>AI 表格列</h5>
              <p>AI 与表格的完美融合， 快速泛读文献，将文献筛选速度提升10倍。</p>
            </div>
            <div className="sr-only">
              <h5>文献筛选对比阅读</h5>
              <p>不仅能提升文献筛选速度， 还能多篇对比泛读，高质量文献一目了然。</p>
            </div>
            <div className="sr-only">
              <h5>AI 文献速读</h5>
              <p>文献图片集中阅读， 结合文献中的关键信息，很实用。</p>
            </div>
            <div className="sr-only">
              <h5>AI 提取参考文献</h5>
              <p>AI 一键获取参考文献， 帮助查找源文链接，很省心。</p>
            </div>
            <div className="sr-only">
              <h5>文献上传</h5>
              <p>支持多种文献上传方式， 还支持文献批量上传，很快速。</p>
            </div>
          </div>
        </div>
        <Image
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]"
          width={1440}
          height={1419}
          src="https://oss.findinai.cn/images/new-section-bg-02-overwhelmed-with-daily-literature-try-ai-for-quick-screening.png"
          alt=""
        />
      </section>
      <section
        className="relative flex justify-center overflow-hidden min-w-full bg-[#EDEFF4]"
      >
        <div className="container flex flex-col z-[2]">
          <h2 className="text-[40px] leading-[52px] font-semibold mt-28">
            精读文献耗时耗力？<br />
            <span className="text-primary">AI 助手</span><br />
            让你事半功倍。
          </h2>
          <p className="text-muted-foreground text-sm leading-7 mt-7">
            找导师不方便？搜索引擎查不明白？<br />
            随时向 Findin AI 提问，让有困惑的你立即获得专业答案。
          </p>
          <div className="-mx-[42px] mt-5 mb-[56px]">
            <Image
              className=""
              width={1170}
              height={715}
              src="https://oss.findinai.cn/images/new-section-03-struggling-with-intensive-literature-reading-ai-assistant-makes-it-effortless.png"
              alt="精读文献耗时耗力？ AI 助手 让你事半功倍。"
            />
            <div className="sr-only">
              <h5>AI 文献问答</h5>
              <p>根据文献内容回答问题，助你深入理解原文， 还可轻松跳至原文对照，是一位靠谱好用的 AI 助理。</p>
            </div>
            <div className="sr-only">
              <h5>AI 划线解释</h5>
              <p>专业名词看不懂？AI 帮你清晰解释。</p>
            </div>
            <div className="sr-only">
              <h5>AI 划线翻译</h5>
              <p>外文文献看太累？AI 帮你专业翻译。</p>
            </div>
            <div className="sr-only">
              <h5>AI 划线改写</h5>
              <p>精彩段落一键引用？AI 帮你学术改写。</p>
            </div>
            <div className="sr-only">
              <h5>AI 划线总结</h5>
              <p>大段内容快速读？AI 帮你精准总结。</p>
            </div>
          </div>
        </div>
        <Image
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]"
          width={1440}
          height={1134}
          src="https://oss.findinai.cn/images/new-section-bg-03-intensive-literature-reading-taking-too-much-time-and-effort-ai-assistant-makes-it-easy.png"
          alt=""
        />
      </section>
      <section
        className="relative flex justify-center overflow-hidden min-w-full bg-[#EDEFF4]"
      >
        <div className="container flex flex-col z-[2] pb-[120px]">
          <h2 className="text-[40px] leading-[52px] font-semibold mt-28">
            笔记知识零碎不成体系？<br />
            Findin 帮你<br />
            <span className="text-primary">高效记笔记。</span>
          </h2>
          <p className="text-muted-foreground text-sm leading-7 mt-7">
            大纲笔记与思维导图，一键自由切换，<br />
            帮助你用结构化思路梳理知识概念。
          </p>
          <NoteSwitchers />
        </div>
        <Image
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]"
          width={1440}
          height={1292}
          src="https://oss.findinai.cn/images/new-section-bg-04-fragmented-notes-lack-of-organization-findin-helps-you-efficiently-take-notes.png"
          alt=""
        />
      </section>
      <section
        className="relative flex justify-center overflow-hidden min-w-full bg-[#EDEFF4]"
      >
        <div className="container flex flex-col items-center z-[2] pb-[50px]">
          <NoteFeatures />
        </div>
        <Image
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]"
          width={1440}
          height={687}
          src="https://oss.findinai.cn/images/new-section-bg-05-3-major-note-features-creating-the-ultimate-note-taking-experience.png"
          alt=""
        />
      </section>
      <section
        className="relative flex justify-center overflow-hidden min-w-full bg-[#EDEFF4]"
      >
        <div className="container flex flex-col z-[2] pb-[65px]">
          <div className="mt-28 relative">
            <h2 className="text-[40px] leading-[52px] font-semibold">
              研究全新领域<br />
              找不着思路？<br />
              <span className="text-primary">让 AI 给你指南。</span>
            </h2>
            <p className="text-muted-foreground text-sm leading-7 mt-7">
              AI 自动生成主题知识框架，牵引你一步步向前探索， <br />
              与 Findin AI 协作，加速课题研究，迅速产出成果。
            </p>
            <Image
              className="absolute -right-[42px] top-0"
              width={795}
              height={300}
              src="https://oss.findinai.cn/images/new-section-06-1-exploring-a-new-research-field-feeling-lost-let-ai-guide-you-01.png"
              alt="研究全新领域 找不着思路？ 让 AI 给你指南。"
            />
            <div className="sr-only">
              <h5>① 创建主题</h5>
              <p>主题式文献管理，高效管理相同研究方向文献。</p>
            </div>
            <div className="sr-only">
              <h5>② AI 知识框架</h5>
              <p>用 AI 一键生成知识框架，快速获得结构式学习指南。</p>
            </div>
            <div className="sr-only">
              <h5>③ 完善主题笔记</h5>
              <p>边读边记录，逐渐加深主题领域理解，沉淀知识资产。</p>
            </div>
          </div>
          <div className="-mx-[42px] mt-7">
            <Image
              className=""
              width={1170}
              height={507}
              src="https://oss.findinai.cn/images/new-section-06-2-exploring-a-new-research-field-feeling-lost-let-ai-guide-you-02.png"
              alt="研究全新领域 找不着北？ 让 AI 给你指南"
            />
            <div className="sr-only">
              <h5>将文献阅读与笔记融合， 带来新知识探索的全新体验。</h5>
              <p>用主题将相同研究方向的文献与笔记放在一起，对主题领域深度挖掘，不仅方便理解，也方便分享、回溯和管理。</p>
            </div>
          </div>
        </div>
        <Image
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]"
          width={1440}
          height={955}
          src="https://oss.findinai.cn/images/new-section-bg-06-exploring-a-new-research-field-feeling-lost-let-ai-guide-you.png"
          alt=""
        />
      </section>
      <section
        className="relative flex justify-center overflow-hidden min-w-full bg-[#EDEFF4]"
      >
        <div className="container flex flex-col z-[2] pb-[58px]">
          <h2 className="text-[40px] leading-[52px] font-semibold mt-28">
            学术写作<br />
            不知如何下手？<br />
            <span className="text-primary">AI 帮你出谋划策。</span>
          </h2>
          <p className="text-muted-foreground text-sm leading-7 mt-7">
            从文献综述、开题选题，到改写润色，<br />
            Findin 学术助手都能帮你。
          </p>
          <Link
            href="/product/literature-review"
            className={cn(
              buttonVariants({ variant: 'default' }),
              "py-0 rounded-full cursor-pointer mt-10",
              "h-[52px] text-lg w-[210px]",
            )}
          >了解 AI 文献综述</Link>
          <div className="-mx-[42px] mt-5">
            <Image
              className=""
              width={1170}
              height={865}
              src="https://oss.findinai.cn/storage/20250730/fc2802a34776e7194642dcc502c76b1d.png"
              alt="07卡片-学术写作 不知如何下手？ AI 帮你出谋划策"
            />
            <div className="sr-only">
              <h5>仅需 3 步， 用 AI 帮你完成文献综述。</h5>
              <p>
                ① 上传并选择文献。 <br />
                ② 描述需要研究的方向。<br />
                ③ AI 生成文献综述。<br />
                根据综述模板，可以生成至少 2 千字左右的文献综述。
              </p>
            </div>
            <div className="sr-only">
              <h5>AI 学术润色</h5>
              <p>写作内容不够专业？AI 帮你学术润色。</p>
            </div>
            <div className="sr-only">
              <h5>AI 学术改写</h5>
              <p>论文内容重复率高？AI 帮你降重改写。</p>
            </div>
            <div className="sr-only">
              <h5>AI 学术翻译</h5>
              <p>快速写出专业英文？AI 帮你学术中英互译。</p>
            </div>
          </div>
        </div>
        <Image
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]"
          width={1440}
          height={1376}
          src="https://oss.findinai.cn/images/new-section-bg-07-academic-writing-do-not-know-where-to-start-ai-helps-you-strategize.png"
          alt=""
        />
      </section>
      <section
        className="relative flex justify-center overflow-hidden min-w-full bg-[#EDEFF4]"
      >
        <div className="container flex flex-col z-[2] pb-[88px]">
          <h2 className="text-[40px] leading-[52px] font-semibold mt-28">
            专业 AI 能力，<br />
            满足你的专业需求，<br />
            <span className="flex items-center">
              <span>使用&nbsp;飞豆</span>
              <span className="pl-1"><TokenIcon size={39} /></span>
              <span>&nbsp;兑换 AI 能力。</span>
            </span>
          </h2>
          <p className="text-muted-foreground text-sm leading-7 mt-7">
            Findin 免费提供核心基础能力，以下 AI 能力按需使用飞豆兑换。
          </p>
          <Link
            href="/pricing"
            className={cn(
              buttonVariants({ variant: 'default' }),
              "py-0 rounded-full cursor-pointer mt-10",
              "h-[52px] text-lg w-[190px]",
            )}
          >了解飞豆</Link>
          <div className="-mx-[42px] mt-[60px]">
            <Image
              className=""
              width={1142}
              height={810}
              src="https://oss.findinai.cn/storage/20250731/1177078cd49fe0967dbde814e6e294f4.png"
              alt="按需付费，不再担心浪费每月会费 使用 飞豆 兑换 AI 能力"
            />
            <div className="sr-only">
              <h5>AI 表格列</h5>
              <p>AI 与表格的完美融合， 快速泛读文献，将文献筛选速度提升10倍。</p>
            </div>
            <div className="sr-only">
              <h5>AI 知识框架</h5>
              <p>用 AI 一键生成知识框架， 快速获得结构式学习指南。</p>
            </div>
            <div className="sr-only">
              <h5>AI 文献问答</h5>
              <p>根据文献内容回答问题， 助你深入理解原文， 还可轻松跳至原文对照。</p>
            </div>
            <div className="sr-only">
              <h5>AI 参考文献获取</h5>
              <p>一键提取文献的参考文献， 找文献引用一步到位。</p>
            </div>
            <div className="sr-only">
              <h5>AI 文献综述</h5>
              <p>仅需 3 步轻松完成， 根据模板，生成至少 2 千字左右文献综述。</p>
            </div>
            <div className="sr-only">
              <h5>AI 学术助手</h5>
              <p>学术润色 、学术改写， 学术翻译， 助你学术写作下笔如有神。</p>
            </div>
          </div>
        </div>
        <Image
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]"
          width={1440}
          height={779}
          src="https://oss.findinai.cn/images/new-section-bg-08-on-demand-payment-no-more-worrying-about-wasting-monthly-fees-use-beans-to-redeem-ai-capabilities.png"
          alt=""
        />
      </section>
      <section className="relative flex flex-col items-center justify-center bg-background">
        <div className={cn(
          "flex flex-col flex-1 items-center justify-center z-[2]",
        )}>
          <h2 className={cn(
            "relative",
            "font-semibold text-[42px] mt-[150px]"
          )}>
            用户故事
          </h2>
          <p className="font-normal text-sm mt-7">了解我们用户的真实使用感受，发现无限可能。</p>
          <div className="-mx-[42px] mt-20">
            <Image
              className=""
              width={1172}
              height={638}
              src="https://oss.findinai.cn/images/new-section-09-user-stories.png"
              alt="AI 列表"
            />
            <div className="sr-only">
              <h5>Claire 中国科学院 硕士</h5>
              <p>首次使用，体验极佳，界面清晰，操作简易。一键解析、智能标注与快速检索功能大大提升了阅读效率，为科研工作带来了前所未有的便捷性。它犹如一位贴身学术秘书，让复杂文献变得轻松易懂，实乃科研人员必备利器。</p>
            </div>
            <div className="sr-only">
              <h5>三毛 中国人民大学 企业管理硕士</h5>
              <p>这个宝藏工具治好了我的“论文恐惧症”，省时、高效又方便！再也不用担心一言不合就3万字以上的论文作业啦！ 首先，它能快速、准确提炼“参考文献”的核心思想，帮助我精准识别是否为目标文献，为论文前期准备阶段节省大量筛选时间！ 其次，不同文献能进行研究背景、研究目的、研究结论等横向对比，结构化！够清晰！能快速获取有效信息！ 最后，参考文献时，可将关键要点收录进“笔记摘录”，太方便了有木有！后期论文编写过程中可回顾，甚至直接复用呢！</p>
            </div>
            <div className="sr-only">
              <h5>豌豆酱 北京大学医学部 科研助理</h5>
              <p>功能设计上非常好，提取关键信息以及做笔记、出文献综述就是 exactly 标准的我们科研都需要的能力！最喜欢 AI 表格列和划线翻译功能，大大提升了我阅读文献的效率，减少了许多工作量。</p>
            </div>
            <div className="sr-only">
              <h5>三颗灯 北京师范大学 应用心理学硕士</h5>
              <p>作为 Findin 的种子用户，亲眼见证了这款产品从一个简单的 Chat 界面，逐步发展到现在这样一款包含许多智能便捷功能，方便学术研究的综合性 AIGC 学术产品。尤其是 AI 表格列这一特色功能，本质上是产品团队综合诸多笔记产品优点后的独创，起码是满足了我个人对一款文献 AI 产品的所有想象。</p>
            </div>
            <div className="sr-only">
              <h5>HYH 中国人民大学 博士</h5>
              <p>见证了 Findin 从初始想法演变成一个覆盖学术研究全流程 AI 工具的整个过程。这个团队对用户反馈十分重视，他们产品的迭代改进非常快速，期待即将上线的对照翻译功能！</p>
            </div>
            <div className="sr-only">
              <h5>JW 浙江大学 MEM</h5>
              <p>Findin 是一款极具价值的工具，尤其对于在职攻读硕士学位的我来说，它的帮助是非常大的。在面对大量文献时，Findin 能够迅速捕捉并总结每篇文献的核心观点和研究方法。我最满意的是，Findin 还能根据我的特定需求，从多篇文献中提炼出相关联的关键信息，使得原本繁琐的文献综述工作变得轻松而高效。 简而言之，Findin 是我学术旅程中的得力助手，它不仅极大地提高了我的学习效率，还能够帮助我高效地完成论文撰写。</p>
            </div>
          </div>
        </div>
        <Image
          className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]"
          width={1440}
          height={1043}
          src="https://oss.findinai.cn/images/new-section-bg-09-user-stories.png"
          alt=""
        />
      </section>

      <section className='flex flex-col items-center'>
        <div className="flex flex-col items-center">
          <div className={cn(
            "flex flex-col flex-1 items-center justify-center",
          )}>
            <h2 className={cn(
              "relative",
              "font-semibold text-[42px] mt-[162px]"
            )}>
              我们希望听到你的声音！
            </h2>
            <p className="font-normal text-sm mt-7">👏 欢迎给予我们使用反馈，帮助 Findin 进步。</p>
          </div>
          <div className="relative w-full flex items-center justify-center mt-8">
            <div className={cn(
              "flex items-center justify-center rounded-full bg-[#F7FCFF]",
              "w-[632px] h-[632px]",
              "md:w-[532px] md:h-[532px]",
            )}>
              <div className={cn(
                "flex items-center justify-center rounded-full bg-[#F0F9FF]",
                "w-[480px] h-[480px]",
                "md:w-[400px] md:h-[400px]",
              )}>
                <div className={cn(
                  "flex items-center justify-center rounded-full bg-[#D8EFFE]",
                  "w-[368px] h-[368px]",
                  "md:w-[308px] md:h-[308px]",
                )}>
                </div>
              </div>
            </div>
            <div className={cn(
              "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",
            )}>
              <Image
                src="https://oss.findinai.cn/storage/20251225/07ad76390a59b51f16734a326ec9ad4e.png"
                width={250}
                height={250}
                alt="FindinAI"
                className="w-[250px] h-auto md:w-[207.5px]"
              />
            </div>
            <div>
              <div
                data-reveal={false}
                className={cn(
                  "absolute bottom-0 right-0 z-0 -translate-x-[45%]",
                  "transition-all duration-500 delay-0",
                  "translate-y-[0%] opacity-0",
                  "data-[reveal=true]:-translate-y-[10%] data-[reveal=true]:opacity-100",
                  "max-w-[137.61px] max-h-[168.74px]",
                  "md:max-w-[114.68px] md:max-h-[140.62px]",
                )}>
                <Image className="w-full h-full" src="https://oss.findinai.cn/images/section-5-figure-abin_1.png" width={137.61} height={168.74} alt="abin" />
              </div>
              <div
                data-reveal={false}
                className={cn(
                  "absolute top-1/2 left-0 z-0 -translate-x-[15%]",
                  "transition-all duration-500 delay-100",
                  "-translate-y-[30%] opacity-0",
                  "data-[reveal=true]:-translate-y-[40%] data-[reveal=true]:opacity-100",
                  "max-w-[125.13px] max-h-[154.76px]",
                  "md:max-w-[104.28px] md:max-h-[128.97px]",
                )}>
                <Image className="w-full h-full" src="https://oss.findinai.cn/images/section-5-figure-lee.png" width={125.13} height={154.76} alt="Lee" />
              </div>
              <div
                data-reveal={false}
                className={cn(
                  "absolute top-1/2 right-0 z-0 -translate-x-[15%]",
                  "transition-all duration-500 delay-200",
                  "-translate-y-[40%] opacity-0",
                  "data-[reveal=true]:-translate-y-[50%] data-[reveal=true]:opacity-100",
                  "max-w-[83.43px] max-h-[109.83px]",
                  "md:max-w-[69.53px] md:max-h-[91.52px]",
                )}>
                <Image className="w-full h-full" src="https://oss.findinai.cn/images/section-5-figure-lucas.png" width={83.43} height={109.83} alt="Lucas" />
              </div>
              <div
                data-reveal={false}
                className={cn(
                  "absolute top-0 left-0 z-0 translate-x-[120%]",
                  "transition-all duration-500 delay-300",
                  "translate-y-[40%] opacity-0",
                  "data-[reveal=true]:translate-y-[30%] data-[reveal=true]:opacity-100",
                  "max-w-[92.1px] max-h-[117.83px]",
                  "md:max-w-[76.75px] md:max-h-[98.19px]",
                )}>
                <Image className="w-full h-full" src="https://oss.findinai.cn/images/section-5-figure-k.png" width={92.1} height={117.83} alt="K" />
              </div>
              <div
                data-reveal={false}
                className={cn(
                  "absolute top-0 right-0 z-0 -translate-x-[110%] translate-y-[40%]",
                  "transition-all duration-500 delay-400",
                  "translate-y-[50%] opacity-0",
                  "data-[reveal=true]:translate-y-[40%] data-[reveal=true]:opacity-100",
                  "max-w-[87.77px] max-h-[115.43px]",
                  "md:max-w-[73.14px] md:max-h-[96.19px]",
                )}>
                <Image className="w-full h-full" src="https://oss.findinai.cn/images/section-5-figure-wiky.png" width={87.77} height={115.43} alt="wiky" />
              </div>
              <div
                data-reveal={false}
                className={cn(
                  "absolute left-0 bottom-0 z-0 translate-x-[175%] -translate-y-[30%]",
                  "transition-all duration-500 delay-400",
                  "-translate-y-[20%] opacity-0",
                  "data-[reveal=true]:-translate-y-[30%] data-[reveal=true]:opacity-100",
                  "max-w-[76.93px] max-h-[99.4px]",
                  "md:max-w-[64.11px] md:max-h-[82.84px]",
                )}>
                <Image className="w-full h-full" src="https://oss.findinai.cn/images/section-5-figure-zh.png" width={76.93} height={99.4} alt="Zh" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="relative flex justify-center bg-background ">
        <div className={cn(
          "flex flex-col items-center z-[2]",
        )}>
          <h2 className={cn(
            "relative",
            "font-semibold text-[42px] mt-[162px]"
          )}>
            这里也能找到我们
          </h2>
          <p className={cn(
            "mt-[12px]",
            "font-normal text-sm mt-7"
          )}>第一时间获取产品更新动态与功能使用帮助。</p>
          <SiteFollowUs />
        </div>
      </section>
      <section className="flex justify-center bg-background">
        <div className="container pb-[150px] relative mt-[140px]">
          <Image
            className=""
            width={1086}
            height={490}
            src="https://oss.findinai.cn/storage/20251218/dff272e8ace73fa14462dbd69b2b5e38.png"
            alt="来试试！ AI 加持下的全新学术研究速度"
          />
          <a
            onClick={() => {
              router.push(
                cookieHasNickname ? '/papers' : '/login'
              );
            }}
            className={cn(
              buttonVariants({ variant: 'default' }),
              "py-0 rounded-full cursor-pointer",
              "h-[52px] text-lg w-[170px] absolute left-1/2 bottom-[210px] -translate-x-1/2 -translate-y-1/2",
            )}
          >
            {cookieHasNickname ? '进入 Findin' : '免费试用'}
          </a>
          <div className="sr-only">
            <h5>来试试！ AI 加持下的全新学术研究速度</h5>
            <p>现在注册，立得100 飞豆</p>
          </div>
        </div>
      </section>
    </>
  );
}
